import { PoppinsNormal } from "common/typographies"
import i18n from "i18n"
import React, { useContext, useState, useEffect, useMemo } from "react"
import AuthContext from "context/auth/authContext"
import { CircularProgress } from "@mui/material"
import { useParams } from "react-router-dom"
import Budget2023Context from "context/budget2023/Budget2023Context"
import ProjectContext from "context/projects/projectContext"
import ModalNoSelection from "./ModalNoSelection"
import ModalCapitulos from "./ModalCapitulos"
import ModalChapterSelected from "./ModalSelected"
import DownloadBudgetModal from "components/Feed/DownloadBudget"
import SendModal from "components/Feed/sendBudgetRefatctor/sendModal"
import ContactContext from "context/contact/contactContext"
import PropTypes from "prop-types"
import ModalExportBankPrice from "./ModalExportBankPrice"
import ModalSelectPlantilla from "../modals/modalSelectPlantilla"
import deleteIcon from "assets/customIcons/topQuickBar/deleteIcon.svg"
import bancoPreciosIcon from "assets/customIcons/topQuickBar/bankPrice.svg"
import ModalDeleteCap from "../modals/ModalDeleteCap"
import ContentCopyIcon from "@mui/icons-material/ContentCopy"
import SyncAltIcon from "@mui/icons-material/SyncAlt"
import wordIcon from "assets/customIcons/topQuickBar/word.svg"
import excelIcon from "assets/customIcons/topQuickBar/excel.svg"
import pdfIcon from "assets/customIcons/topQuickBar/pdf.svg"
import MoveDownIcon from "@mui/icons-material/MoveDown"
import TreeViewModal from "../modals/TreeViewModal"
import { useWrapperModals } from "context/wrapperModals/WrapperModalsContext"
import { countSelectedInTree } from "utils/budgetUtils"

const TopQuickBudgetMenu = ({ soyFinal }) => {
  const {
    chaptersChecked,
    partsChecked,
    loadingCaps,
    groupParts,
    selectedPartGroup,
    selectedChaptersGroup,
    budgetTree,
    selectPartsGroup,
    getSelectedBudget2,
    errorAgrupar,
    loadingAgruparChapters,
    loadingAgruparParts,
    uncheckAll,
    deleteCapitulo,
    deletePartidav2,
    cleanChapters,
    cleanParts,
    duplicateParts,
    setIsContradictingPart,
    exportToPdf,
    exportToWord,
    exportToExcel,
    loadingIcon,
    setLoadingIcon,
    movePartsToChapter,
    isBudgetClosed,
  } = useContext(Budget2023Context)
  const { user, freeTrialExpired } = useContext(AuthContext)
  const [name, setName] = useState("")
  const [openAgrupar, setOpenAgrupar] = useState(false)
  const [openCaps, setOpenCaps] = useState(false)
  const [estadoLista, setEstadoLista] = useState([])
  const [estadoListaCaps, setEstadoListaCaps] = useState([])
  const [openSelected, setOpenSelected] = useState(false)
  const { projectInfo } = useContext(ProjectContext)
  const { projectId } = useParams()
  const { Contacts } = useContext(ContactContext)

  const [openEliminate, setOpenEliminate] = useState(false)
  const [deletingParts, setDeletingParts] = useState(false)

  const { newModalPart } = useWrapperModals()

  const selectedCounts = useMemo(
    () => countSelectedInTree(budgetTree?.subcapitulos),
    [chaptersChecked, partsChecked],
  )

  const handleDelete = async () => {
    if (chaptersChecked.length > 0) {
      setOpenEliminate(true)
    }
    if (partsChecked.length > 0) {
      setDeletingParts(true)
      for (let index = 0; index < partsChecked.length; index++) {
        await deletePartidav2(
          partsChecked[index].chapterId,
          partsChecked[index].partidaId,
          partsChecked[index].accountId,
        )
      }
      setDeletingParts(false)
      await cleanParts()
    }
  }

  useEffect(() => {
    if (chaptersChecked.length > 0 || partsChecked.length > 0) {
      selectPartsGroup([], budgetTree.subcapitulos)
      getSelectedBudget2([], budgetTree.subcapitulos)
    }
  }, [chaptersChecked.length, partsChecked.length])

  useEffect(() => {
    setEstadoLista(selectedPartGroup)
  }, [selectedPartGroup])

  useEffect(() => {
    setEstadoListaCaps(selectedChaptersGroup)
  }, [selectedChaptersGroup])

  const agruparPartidas = async () => {
    if (errorAgrupar == false) {
      if (estadoLista.length == 0) {
        setName("las partidas")
        setOpenAgrupar(true)
      } else {
        groupParts(projectInfo.projectId)
      }
    } else {
      setOpenSelected(true)
    }
  }

  const agruparCapitulos = async () => {
    if (estadoListaCaps.length == 0) {
      //modal no has agrupado nada
      setName("los capítulos")
      setOpenAgrupar(true)
    } else {
      //antes de esto mensaje de aviso
      setOpenCaps(true)
    }
  }

  const handleDuplicateParts = async () => {
    if (partsChecked?.length > 0) {
      await duplicateParts(partsChecked)
    }
  }

  const handleContradictPart = () => {
    setIsContradictingPart(true)
    newModalPart.setProperty({
      open: true,
      chapterId: partsChecked[0].chapterId,
      partida: partsChecked[0],
      from: "TopQuickBudgetMenu",
    })
  }

  const handleExportPdf = async () => {
    await exportToPdf(partsChecked, chaptersChecked)
  }

  const handleExportWord = async () => {
    // await exportToWord()
  }

  const handleExportExcel = async () => {
    await exportToExcel(partsChecked, chaptersChecked)
  }

  const [isTreeViewVisible, setIsTreeViewVisible] = useState(false)

  const handleMoveParts = () => {
    setIsTreeViewVisible(true)
  }

  const changeCheck = e => {
    if (!e) var e = window.event
    e.cancelBubble = true
    if (e.stopPropagation) e.stopPropagation()
    if (partsChecked.length > 0 || chaptersChecked.length > 0) {
      uncheckAll()
    }
  }

  const [openDownloadBudgetModal, setOpenDownloadBudgetModal] = useState(false)
  const [openSendBudgetModal, setOpenSendBudgetModal] = useState(false)
  const [openExportBankPrice, setOpenExportBankPrice] = useState(false)
  const [openSelectPlantilla, setOpenSelectPlantilla] = useState(false)

  const getIconStyle = disabled => ({
    color: user
      ? user["custom:role"] === "WORKER" || freeTrialExpired
        ? "#C4C4C4"
        : "white"
      : "#C4C4C4",
    width: "19px",
    marginTop: "-2px",
    marginRight: "10px",
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.5 : 1,
  })

  const isWorker = () => {
    return user && user["custom:role"] === "WORKER"
  }

  const canDelete = () => {
    if (isContradicted()) return false
    if (isCertificated()) return false
    if (!user) return false
    if (isWorker() || freeTrialExpired) return false
    if (isBudgetClosed) return false

    return true
  }

  const isContradicted = () => {
    const isContradicted = p => p.contradicted_by_id !== null

    if (partsChecked.some(isContradicted)) return true
    return false
  }

  const somePartsInSelectionMatch = predicate => {
    if (partsChecked.some(predicate)) return true

    const chapterIds = new Set(chaptersChecked.map(c => c.chapterId))
    if (chapterIds.size === 0) return false

    const search = (subs, onlySelected = false) =>
      subs.some(sub => {
        const selected = chapterIds.has(sub.chapterId)
        return (
          (sub.partidas?.length &&
            (onlySelected || selected) &&
            sub.partidas.some(predicate)) ||
          (sub.subcapitulos?.length &&
            search(sub.subcapitulos, selected || onlySelected))
        )
      })

    return search(budgetTree.subcapitulos)
  }

  const isCertificated = () =>
    somePartsInSelectionMatch(
      p => p.cert_previous !== 0 || p.cert_previous_price !== 0,
    )

  const isCertifiedAbove100 = () =>
    somePartsInSelectionMatch(p => p.cert_previous > p.quantity)

  const isCertifiedBelowOrEqualTo100 = () =>
    somePartsInSelectionMatch(p => p.cert_previous <= p.quantity)

  const getContradictPartTooltip = () => {
    if (!isBudgetClosed) {
      return i18n.t("topQuickBudgetMenu.cantContradictOpenedBudget")
    }
    if (isCertifiedAbove100()) {
      return i18n.t("topQuickBudgetMenu.contradictPartAbove100")
    }
    if (!isCertificated()) {
      return i18n.t("topQuickBudgetMenu.contradictPart")
    }
    if (isCertifiedBelowOrEqualTo100()) {
      return i18n.t("topQuickBudgetMenu.contradictPartBelowOrEqualTo100")
    }
  }

  const icons = [
    {
      component: <img src={deleteIcon} style={getIconStyle(!canDelete())} />,
      showCondition: true,
      action: () => {
        canDelete() && handleDelete()
      },
      tooltip: isBudgetClosed
        ? i18n.t("topQuickBudgetMenu.cantDeleteClosedBudget")
        : isCertificated()
          ? i18n.t("topQuickBudgetMenu.cantDeleteCertificated")
          : isContradicted()
            ? i18n.t("topQuickBudgetMenu.cantDeleteContradicted")
            : i18n.t("topQuickBudgetMenu.delete"),
      showLoading: false,
    },
    {
      component: (
        <SyncAltIcon
          style={getIconStyle(!isBudgetClosed || isCertifiedAbove100())}
          data-element="contradictPartBtn"
        />
      ),
      showCondition: true,
      action: () => {
        isBudgetClosed && handleContradictPart(partsChecked)
      },
      tooltip: getContradictPartTooltip(),
    },
    {
      component: (
        <ContentCopyIcon
          style={getIconStyle(isBudgetClosed || chaptersChecked.length > 0)}
        />
      ),
      showCondition: true,
      action: () => {
        if (!isBudgetClosed && chaptersChecked.length === 0) {
          handleDuplicateParts()
        }
      },
      tooltip: isBudgetClosed
        ? i18n.t("topQuickBudgetMenu.cantDuplicateClosedBudget")
        : chaptersChecked.length > 0
          ? i18n.t("topQuickBudgetMenu.cantDuplicateChapter")
          : i18n.t("topQuickBudgetMenu.duplicatePart"),
      showLoading: chaptersChecked.length > 0 ? false : true,
    },
    {
      component: (
        <img
          src={bancoPreciosIcon}
          style={{
            ...getIconStyle(),
            width: "23px",
            height: "25px",
          }}
        />
      ),
      showCondition: chaptersChecked.length == 0,
      action: () => {
        user &&
          !(isWorker() || freeTrialExpired) &&
          setOpenExportBankPrice(true)
      },
      tooltip: i18n.t("topQuickBudgetMenu.importToBankPrice"),
      showLoading: false,
    },
    {
      component: <img src={pdfIcon} style={getIconStyle()} />,
      showCondition:
        (chaptersChecked.length == 0 && partsChecked.length > 0) ||
        (partsChecked.length == 0 && chaptersChecked.length > 0),
      action: () => {
        user && !(isWorker() || freeTrialExpired) && handleExportPdf()
      },
      tooltip: i18n.t("topQuickBudgetMenu.exportToPdf"),
      showLoading: true,
    },
    {
      component: <img src={wordIcon} style={getIconStyle()} />,
      showCondition: false,
      action: () => {
        // user && !(isWorker() || freeTrialExpired) && handleExportWord()
      },
      tooltip: i18n.t("topQuickBudgetMenu.exportToWord"),
      showLoading: true,
    },
    {
      component: <img src={excelIcon} style={getIconStyle()} />,
      showCondition:
        (chaptersChecked.length == 0 && partsChecked.length > 0) ||
        (partsChecked.length == 0 && chaptersChecked.length > 0),
      action: () => {
        user && !(isWorker() || freeTrialExpired) && handleExportExcel()
      },
      tooltip: i18n.t("topQuickBudgetMenu.exportToExcel"),
      showLoading: false,
    },
    {
      component: <MoveDownIcon style={getIconStyle(isBudgetClosed)} />,
      showCondition: partsChecked.length == 1,
      action: () => {
        !isBudgetClosed && handleMoveParts()
      },
      tooltip: !isBudgetClosed
        ? i18n.t("topQuickBudgetMenu.movePartToChapter")
        : i18n.t("topQuickBudgetMenu.cantMovePartClosedBudget"),
      showLoading: false,
    },
  ]

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: "0px",
          left: "0px",
          width: "100%",
          height: "47px",
          backgroundColor: "#4461D7",
          zIndex: "1300",
          paddingTop: "15px",
        }}
      >
        <div className="inline">
          <div style={{ marginLeft: "10%" }} className="inline">
            <div className="tdcheckColumn">
              <input
                className="form-check-input"
                type="checkbox"
                checked={
                  selectedCounts.chapters > 0 || selectedCounts.parts > 0
                }
                onChange={() => {}}
                id="flexCheckDefault"
                style={{
                  width: "13px",
                  height: "13px",
                  cursor: "pointer",
                  zIndex: "5",
                  position: "relative",
                }}
                onClick={e => {
                  changeCheck(e)
                }}
              ></input>
            </div>
            {(selectedCounts.chapters > 0 || selectedCounts.parts > 0) && (
              <PoppinsNormal style={{ color: "white" }}>
                {selectedCounts.chapters > 0 && selectedCounts.parts > 0
                  ? `${selectedCounts.chapters} ${selectedCounts.chapters === 1 ? i18n.t("capitulo") : i18n.t("capitulos")} · ${selectedCounts.parts} ${selectedCounts.parts === 1 ? i18n.t("partida seleccionada") : i18n.t("partidas seleccionadas")}`
                  : selectedCounts.chapters > 0
                    ? `${selectedCounts.chapters} ${selectedCounts.chapters === 1 ? i18n.t("capitulo seleccionado") : i18n.t("capitulos seleccionados")}`
                    : `${selectedCounts.parts} ${selectedCounts.parts === 1 ? i18n.t("partida seleccionada") : i18n.t("partidas seleccionadas")}`}
              </PoppinsNormal>
            )}
          </div>
          <div
            style={{
              justifyContent: "center",
              width: "100%",
              textAlign: "center",
              position: "absolute",
              display: "flex",
              gap: "20px",
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              marginTop: "-1px",
            }}
          >
            {icons.map(
              (icon, index) =>
                icon.showCondition && (
                  <div key={index} style={{ position: "relative" }}>
                    {loadingIcon.isLoading &&
                    icon.showLoading &&
                    loadingIcon.index === index &&
                    !isTreeViewVisible ? (
                      <CircularProgress
                        size={24}
                        style={{ marginLeft: "auto", marginRight: "3px" }}
                      />
                    ) : (
                      React.cloneElement(icon.component, {
                        onClick: () => {
                          setLoadingIcon({
                            isLoading: true,
                            index: index,
                          })
                          icon.action()
                        },
                        className: `iconoShow-${index + 1}`,
                        onMouseEnter: () => {
                          document.querySelector(
                            `.icono-${index + 1}`,
                          ).style.display = "block"
                        },
                        onMouseLeave: () => {
                          document.querySelector(
                            `.icono-${index + 1}`,
                          ).style.display = "none"
                        },
                      })
                    )}
                    <div
                      className={`icono-${index + 1}`}
                      style={{
                        display: "none",
                        position: "absolute",
                        left: "50%",
                        transform: "translateX(-50%)",
                        top: "30px",
                      }}
                    >
                      <div className="recuadro" style={{ width: "125px" }}>
                        <div
                          className="recuadroPico"
                          style={{
                            left: "50%",
                            transform: "translateX(-50%)",
                          }}
                        ></div>
                        {i18n.t(icon.tooltip)}
                      </div>
                    </div>
                  </div>
                ),
            )}
          </div>
        </div>
      </div>
      <ModalNoSelection
        open={openAgrupar}
        setOpen={setOpenAgrupar}
        nombre={name}
      />
      <ModalChapterSelected open={openSelected} setOpen={setOpenSelected} />
      <ModalCapitulos
        open={openCaps}
        setOpen={setOpenCaps}
        projectId={projectId}
      />
      {openDownloadBudgetModal && (
        <DownloadBudgetModal
          soyFinal={soyFinal}
          open={openDownloadBudgetModal}
          setOpen={setOpenDownloadBudgetModal}
          name={projectInfo.name}
        />
      )}
      {openSendBudgetModal && (
        <SendModal
          open={openSendBudgetModal}
          setOpen={setOpenSendBudgetModal}
          contactos={Contacts}
        />
      )}
      {openExportBankPrice && (
        <ModalExportBankPrice
          open={openExportBankPrice}
          setOpen={setOpenExportBankPrice}
        />
      )}
      {openSelectPlantilla && (
        <ModalSelectPlantilla
          open={openSelectPlantilla}
          setOpen={setOpenSelectPlantilla}
        />
      )}
      <ModalDeleteCap
        openEliminate={openEliminate}
        setOpenEliminate={setOpenEliminate}
        chapterList={true}
      />
      <TreeViewModal
        open={isTreeViewVisible}
        setOpen={setIsTreeViewVisible}
        chapters={budgetTree.subcapitulos}
        callback={selectedChapter => {
          movePartsToChapter(partsChecked, selectedChapter.chapterId, projectId)
          setIsTreeViewVisible(false)
        }}
      />
    </>
  )
}

TopQuickBudgetMenu.propTypes = {
  soyFinal: PropTypes.bool,
}

export default TopQuickBudgetMenu
